import { render, staticRenderFns } from "./TotalSales.vue?vue&type=template&id=5aee50f8&scoped=true&"
import script from "./TotalSales.vue?vue&type=script&lang=js&"
export * from "./TotalSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee50f8",
  null
  
)

export default component.exports